export enum StatusCode {
  INTERNAL_SERVER_ERROR = 500,
  BAD_REQUEST = 400,
}
